import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import * as R from "ramda";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import { read } from "Helpers/LocalStorage";
import { addPartLocal, getStuffFittingCombo } from "Stores/actions";
import { useTranslation } from 'react-i18next';
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";

function NewProduct({ prow, onAddNew }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [formValid, setFormValid] = useState({});
    const [loading, setLoading] = useState(false);
    const [checkValid, setCheckValid] = useState(false);
    const { selectedBrandYaragh } = useSelector((state) => ({
        selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
    }));
    const [controls, setControls] = useSetState({
        yaraghProductList: {
            type: "select",
            selectItems: [],
            value: "",
            validation: null,
        },
        count: {
            type: "number",
            value: 0,
            validation: {
                required: true,
                isNumeric: true,
                min: 0,
            },
        },
    });

    useEffect(() => {
        onClear();
        (async () => {
            setLoading(true);
            const stuffFittingCombo = await dispatch(getStuffFittingCombo({
                KeyGroup: read("groupKey"),
                KeyUser: read("userKey"),
                idBrandFitting: selectedBrandYaragh.Id,
            }));
            setControls({ yaraghProductList: { selectItems: stuffFittingCombo, value: stuffFittingCombo[0] }});
            setLoading(false);
        })()
    },[])
    
    const onClear = () => {
        setCheckValid(false);
        setFormValid({ count: false });
        setControls({ count: { value: 0 } });
    }

    const setValue = async (name, value, validation) => {
        setControls({ [name]: { value: value } });
        setFormValid((prev) => ({ ...prev, [name]: validation }));
    }

    const autoCompleteHandler = async (e, value) => {
        const controlName = e.target.id.split("-")[0];
        setControls({ [controlName]: { value: value } });
    };

    const onFinish = async (e) => {
        e.preventDefault();
        if (!R.isEmpty(formValid) && Object.values(formValid).every((item) => item === true)) {
            const { yaraghProductList, count } = controls;
            try {
                setLoading(true);
                const data = {
                    KeyGroup: read("groupKey"),
                    KeyUser: read("userKey"),
                    idRangeTechnicalFitting: prow.Id,
                    idStuffFitting: yaraghProductList.value.value,
                    count: count.value,
                };
                await dispatch(addPartLocal(data));
                onAddNew();
                setLoading(false);
            } catch (e) {
                console.log('new part local', e);
                setLoading(false);
            }
        } else {
            setCheckValid(true);
            showNotify({
                text: t('correctFormDataRequired'),
                customClass: "error",
            });
        }
    }

    return (
        <Grid container spacing={2} className="box-border">
            <Grid item xs={12} className="text-center py-2 mb-3" style={{backgroundColor: '#E4E8E8', borderRadius: '3px 3px 0 0'}}>
                <strong>{`${t('addNewStuff')}`}</strong>
            </Grid>
            {
                !loading ?
                <Grid container spacing={2} className="px-3 pb-2">
                    {
                        Object.keys(controls).map((key, index) => {
                            return (
                                <>
                                    {
                                        controls[key].type === "select" &&
                                        <Grid item key={key + index} sm={6} xs={12}>
                                            <MuiAutoComplete
                                                loading={loading}
                                                options={controls[key].selectItems}
                                                label={<Translator id={key} />}
                                                value={controls[key].value}
                                                id={key}
                                                onChange={autoCompleteHandler}
                                            />
                                        </Grid>
                                    }
                                    {
                                        controls[key].type === "number" &&
                                        <Grid item key={key + index} sm={3} xs={12}>
                                            <Input
                                                setValue={setValue.bind(this)}
                                                name={key}
                                                placeholder={t(key)}
                                                validation={controls[key].validation}
                                                label={<Translator id={key} />}
                                                type="text"
                                                checkValid={checkValid}
                                                value={controls[key].value}
                                            />
                                        </Grid>
                                    }
                                </>
                            );
                        })
                    }
                    <Grid item sm={3} xs={12} className="d-flex align-items-center">
                        <MuiButton
                            loading={loading}
                            color="primary"
                            title={<Translator id="ezafe_be_list" />}
                            onClick={onFinish}
                            disabled={read("ShisheRules").accessRegister === false}
                            fullwidthOnSm
                            className="w-100"
                        />
                    </Grid>
                </Grid>
                : <div className="w-100 d-flex justify-content-center">
                    <InnerCircularProgress />
                </div>
            }
        </Grid>
    );
}

export default NewProduct;